import { AfterViewInit, Component, OnInit } from '@angular/core';
import { InvoiceDetailType } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-gift-voucher-thank-you',
  templateUrl: './gift-voucher-thank-you.component.html',
  styleUrls: ['./gift-voucher-thank-you.component.scss']
})
export class GiftVoucherThankYouComponent extends BaseComponent implements OnInit, AfterViewInit {

  totalAmount: number = 0;
  voucherUrl: string = '';
  resultItems: any[] = [];
  vouchers:any;

  ngOnInit() {
    this.app.spinner.show();
    this.app.loadingDescription = 'Loading...';
    this.app.pageTitle = '';
    this.loadExternalScript('https://addevent.com/libs/atc/1.6.1/atc.min.js');
    
    this.baseTriggerChild.subscribe(() => {
      this.app.pageTitle = 'Result';
      
      var strVouchers = this.app.storageService.getItem(AppConstants.GiftVoucherUrls);
      this.resultItems = JSON.parse(this.app.storageService.getItem(AppConstants.BookingTreatmentResult));

      this.resultItems.forEach((e, i) => {
        this.totalAmount += e.fee;
        if (e.invoiceDetailType == InvoiceDetailType.GiftVoucher) {

          if(this.app.stringService.isNotEmpty(strVouchers))
          {
            this.vouchers = JSON.parse(strVouchers);
            if(this.vouchers!=null && this.vouchers.orderedDetails!=null)
            {
              e.url = this.vouchers.orderedDetails[i].url;
            }
          }
        }
      });
      
      this.app.spinner.hide();
    });
  }

  ngAfterViewInit(): void {
    this.start();
  }
  
  loadExternalScript(scriptUrl: string): any {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script')
      scriptElement.src = scriptUrl
      scriptElement.onload = resolve
      document.body.appendChild(scriptElement);
    });
  }
  
  gotoHome() {
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
  }

  gotoVoucher() {
    this.app.router.navigate([AppConstants.RouteGiftVouchers]);
  }

  download(item) {
    window.open(item.url, '_target');
  }

}
